export type AudioType = 'pronunciation' | 'example';

export function buildAudioUrl(
  baseUrl: string,
  wordId: string,
  type: AudioType,
  token?: string
): string {
  const params = new URLSearchParams({ wordId, type });
  if (token) {
    params.set('token', token);
  }
  return `${baseUrl}?${params.toString()}`;
}
